<template>
  <div class="use-case" :style="usecase.isGrey ? 'background: #fafafa': ''">
    <div class="page-container">
      <div class="header">
        <div class="title">
          {{usecase.title}}
        </div>
        <div class="sub-title">
          {{usecase.subtitle}}
        </div>
      </div>
      <div class="content">
        <ul class="tabs">
          <li
          :class="[usecaseactive === index? 'active': '', usecase.content.length > 7 ?'small':'']"
          @click="usecaseactive = index"
          v-for="(item,index) in usecase.content"
          :key="index">
            <span>{{item.title}}</span>
          </li>
        </ul>
        <div class="tab-content">
          <div class="left" style="padding-right: 70px;">
            <div class="title">{{usecase.content[usecaseactive].title}}</div>
            <div class="sub-title" v-html="usecase.content[usecaseactive].subtitle"></div>
            <div class="button" v-if="usecase.content[usecaseactive].button" @click="usecase.content[usecaseactive].buttonCallback">
              <div>{{usecase.content[usecaseactive].button}}</div>
              <img :src="usecase.content[usecaseactive].buttonIcon" alt="">
            </div>
          </div>
          <div class="right">
            <img :src="usecase.content[usecaseactive].img" alt="">
          </div>
<!--          <div class="left" v-if="usecaseactive%2==0" style="padding-left: 70px;">-->
<!--            <div class="title">{{usecase.content[usecaseactive].title}}</div>-->
<!--            <div class="sub-title" v-html="usecase.content[usecaseactive].subtitle"></div>-->
<!--            <div class="button" v-if="usecase.content[usecaseactive].button">-->
<!--              <div>{{usecase.content[usecaseactive].button}}</div>-->
<!--              <img :src="usecase.content[usecaseactive].buttonIcon" alt="">-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      usecaseactive: 0,
    }
  },
  props: {
    usecase: {
      type: Object,
      default: () => {
        return {
          title: '使用场景',
          subtitle: '集视频、语音、文档、课件共享、直播于一体，使用简单，音画清晰，实时互动',
          content: [{
            title: '远程会诊',
            subtitle: '跨越时间地域限制，与知名专家面对面。结合远程超声，视频影像传输等，为专家提供更多细节，让每个人都可以享受优质的医疗服务。',
            img: require('@/assets/resolution/onlineEducation/img2.png')
          }, {
            title: '远程会诊2',
            subtitle: '跨越时间地域限制，与知名专家面对面。结合远程超声，视频影像传输等，为专家提供更多细节，让每个人都可以享受优质的医疗服务。2',
            img: require('@/assets/resolution/onlineEducation/img2.png')
          }]
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
.use-case {

  .content {
    .tabs  {
      margin-top: 51px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      border-bottom: 1px solid #999999;
      li {
        font-size: 18px;
        color: #999999;
        cursor: pointer;
        word-break: keep-all;
        white-space: nowrap;
        span {
          display: inline-block;
          padding-bottom: 15px;
          position: relative;
        }
      }
      li.active {
        font-size: 21px;
        font-weight: 600;
        color: #6c96f8;
        span {
          &::after{
            position: absolute;
            bottom: 0;
            display: block;
            content: '';
            height: 3px;
            width: 100%;
            background: #6692f9;
          }
        }
      }
      li.small {
        font-size: 18px;
      }
    }
    .tab-content {
      margin-top: 67px;
      display: flex;
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .title {
          font-weight: 600;
          color: #333333;
          font-size: 21px;
        }
        .sub-title {
          font-size: 18px;
          color: #666666;
          margin-top: 15px;
        }
      }
      .right {
        flex: 1;
        img {
          width: 100%;
        }
      }
      .button {
        display: flex;
        align-items: center;
        margin-top: 24px;
        cursor: pointer;
          div {
            color: #3B72F2;
            font-size: 18px;
            margin-right: 5px;
          }
          img {
            width: 15px;
          }
      }
    }
  }
}
</style>
